(function () {
  'use strict';

  function initSection(section) {
    var track = section.querySelector('[data-press-track]');
    if (!track) return;
    var viewport = section.querySelector('.oddit-section-featured-press-single__viewport');
    var slides = section.querySelectorAll('[data-press-slide]');
    if (slides.length < 2) return;
    var dots = section.querySelectorAll('[data-press-dot]');

    var index = 0;
    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';
    var intervalSec = parseFloat(section.getAttribute('data-autoplay-speed')) || 5;
    var timerId = null;

    function goTo(next) {
      index = ((next % slides.length) + slides.length) % slides.length;
      track.style.transition = '';
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle(
          'oddit-section-featured-press-single__slide--active',
          i === index
        );
      }
      for (var j = 0; j < dots.length; j++) {
        var isActive = j === index;
        dots[j].classList.toggle(
          'oddit-section-featured-press-single__dot--active',
          isActive
        );
        dots[j].setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      timerId = window.setInterval(function () {
        goTo(index + 1);
      }, intervalSec * 1000);
    }

    function stopAutoplay() {
      if (timerId !== null) {
        window.clearInterval(timerId);
        timerId = null;
      }
    }

    for (var k = 0; k < dots.length; k++) {
      (function (i) {
        dots[i].addEventListener('click', function () {
          goTo(i);
          // Reset autoplay so the next auto-advance is a fresh interval from
          // the user's manual selection rather than firing immediately.
          startAutoplay();
        });
      })(k);
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', startAutoplay);

    /* ---------- Drag / swipe ---------- */

    if (viewport) {
      var drag = {
        active: false,
        pointerId: null,
        startX: 0,
        startY: 0,
        lastX: 0,
        axisLocked: false,
        isHorizontal: false,
        startTime: 0,
        suppressNextClick: false
      };

      var DIRECTION_THRESHOLD = 6;
      var DISTANCE_THRESHOLD = 40;
      var VELOCITY_THRESHOLD = 0.35;

      function onPointerDown(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        drag.active = true;
        drag.pointerId = e.pointerId;
        drag.startX = e.clientX;
        drag.startY = e.clientY;
        drag.lastX = e.clientX;
        drag.axisLocked = false;
        drag.isHorizontal = false;
        drag.startTime = e.timeStamp || Date.now();
        stopAutoplay();
      }

      function onPointerMove(e) {
        if (!drag.active || e.pointerId !== drag.pointerId) return;
        var dx = e.clientX - drag.startX;
        var dy = e.clientY - drag.startY;

        if (!drag.axisLocked) {
          if (Math.abs(dx) < DIRECTION_THRESHOLD && Math.abs(dy) < DIRECTION_THRESHOLD) return;
          drag.isHorizontal = Math.abs(dx) > Math.abs(dy);
          drag.axisLocked = true;
          if (!drag.isHorizontal) {
            // Vertical scroll — let the page take over and resume autoplay.
            drag.active = false;
            startAutoplay();
            return;
          }
          try { viewport.setPointerCapture(drag.pointerId); } catch (err) {}
          track.style.transition = 'none';
        }

        drag.lastX = e.clientX;
        var width = viewport.clientWidth || 1;
        var basePx = -index * width;
        var nextPx = basePx + dx;
        var min = -(slides.length - 1) * width;
        // Soft clamp at the edges so it feels bounded but not rigid.
        if (nextPx > 0) nextPx = nextPx / 3;
        else if (nextPx < min) nextPx = min + (nextPx - min) / 3;
        track.style.transform = 'translateX(' + nextPx + 'px)';
        if (e.cancelable) e.preventDefault();
      }

      function endDrag(e) {
        if (!drag.active || (e && e.pointerId !== drag.pointerId)) return;
        var wasHorizontal = drag.isHorizontal;
        drag.active = false;
        try { viewport.releasePointerCapture(drag.pointerId); } catch (err) {}
        drag.pointerId = null;

        if (!wasHorizontal) {
          startAutoplay();
          return;
        }

        var dx = drag.lastX - drag.startX;
        if (Math.abs(dx) > DIRECTION_THRESHOLD) drag.suppressNextClick = true;
        var elapsed = ((e && e.timeStamp) || Date.now()) - drag.startTime;
        var velocity = elapsed > 0 ? Math.abs(dx) / elapsed : 0;
        var target = index;

        if (Math.abs(dx) > DISTANCE_THRESHOLD || velocity > VELOCITY_THRESHOLD) {
          target = dx < 0 ? index + 1 : index - 1;
        }

        // Clamp — no wraparound on a manual swipe so you can't overshoot past the ends.
        if (target < 0) target = 0;
        if (target > slides.length - 1) target = slides.length - 1;
        goTo(target);
        startAutoplay();
      }

      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointermove', onPointerMove);
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      // Swallow the synthetic click the browser fires after a drag-release, so
      // dragging onto a logo link doesn't navigate.
      viewport.addEventListener('click', function (e) {
        if (drag.suppressNextClick) {
          drag.suppressNextClick = false;
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    // Pause when section is offscreen to avoid background work.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            startAutoplay();
          } else {
            stopAutoplay();
          }
        });
      }, { threshold: 0.1 });
      io.observe(section);
    } else {
      startAutoplay();
    }

    goTo(0);
  }

  function init() {
    var sections = document.querySelectorAll('[data-press-slider]');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
